import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TableCell, Typography } from '@material-ui/core';
import { styled, makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

const NoPaddingTableCell = styled(TableCell)({
  padding: 0,
  border: 'none',
  textAlign: 'center',
});

const useStyles = makeStyles(() => ({
  healthyBottom: {
    paddingBottom: 5,
  },
  moreBottomPadding: {
    paddingBottom: 20,
  },
  topBottomMargins: {
    marginTop: 20,
    marginBottom: 10,
  },
  beta: {
    color: '#1d69ff',
    paddingBottom: 5,
    fontWeight: 450,
  },
}));

const TelemetryTableTitleCell = ({ title, type, blank }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <NoPaddingTableCell key={Math.random() * 10000}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        key={Math.random() * 10000}
        className={classes.topBottomMargins}
      >
        {!blank ? (
          <div>
            <Grid item container key={Math.random() * 10000}>
              {title == 'Phosphorus' ? (
                <Grid item>
                  <Typography
                    variant="subtitle1"
                    display="inline"
                    key={Math.random() * 10000}
                    className={classes.healthyBottom}
                  >
                    {title}
                  </Typography>
                  <Typography variant="subtitle1" display="inline" key={Math.random() * 10000} className={classes.beta}>
                    {` ${t('beta')}`}
                  </Typography>
                </Grid>
              ) : (
                <Typography variant="subtitle1" key={Math.random() * 10000} className={classes.healthyBottom}>
                  {title}
                </Typography>
              )}
            </Grid>
            <Grid
              container
              item
              className={classes.healthyBottom}
              direction="column"
              alignItems="center"
              justifyContent="flex-start"
              key={Math.random() * 10000}
            >
              <Typography
                variant="subtitle2"
                key={Math.random() * 10000}
                className={type === undefined ? classes.moreBottomPadding : classes.healthyBottom}
              >
                {type}
              </Typography>
            </Grid>
          </div>
        ) : (
          <Grid container item className={classes.healthyBottom} key={Math.random() * 10000}>
            <Typography variant="subtitle1" key={Math.random() * 10000} className={classes.healthyBottom} />
          </Grid>
        )}
      </Grid>
    </NoPaddingTableCell>
  );
};

TelemetryTableTitleCell.propTypes = {
  title: PropTypes.string,
  blank: PropTypes.bool,
  type: PropTypes.string,
};

TelemetryTableTitleCell.defaultProps = {
  title: '',
  blank: false,
  type: undefined,
};

export default TelemetryTableTitleCell;
